import { createI18n } from 'vue-i18n';
import fr from './locales/fr';
import en from './locales/en';
import it from './locales/it';
import es from './locales/es';
import de from './locales/de';
import nl from './locales/nl';
import pt from './locales/pt';
import co from './locales/co';

export const SUPPORTED_LOCALES = ['fr', 'en', 'it', 'es', 'de', 'nl', 'pt', 'co'];
export const DEFAULT_LOCALE = 'fr';
const STORAGE_KEY = 'locale';

function detectLocale() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved && SUPPORTED_LOCALES.includes(saved)) {
    return saved;
  }
  const browser = (navigator.language || '').slice(0, 2).toLowerCase();
  return SUPPORTED_LOCALES.includes(browser) ? browser : DEFAULT_LOCALE;
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { fr, en, it, es, de, nl, pt, co },
});

export function setLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return;
  i18n.global.locale.value = locale;
  localStorage.setItem(STORAGE_KEY, locale);
  document.documentElement.setAttribute('lang', locale);
}

document.documentElement.setAttribute('lang', i18n.global.locale.value);

export default i18n;
